import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from "react";
import { CircleEventNode } from "./CircleEventNode";
function ProcessFlowStartNode({ data }) {
    if (!data) return null;
    return /*#__PURE__*/ _jsx(CircleEventNode, {
        data: data,
        fallbackLabel: "Start"
    });
}
export default /*#__PURE__*/ memo(ProcessFlowStartNode);

//# sourceMappingURL=StartNode.js.map